import { C as n } from "./Content-DQidYhT2.mjs";
const e = {
  locales: ["en", "es", "fr", "de", "it", "pt", "tr", "ru", "ua", "ja", "zh", "ko"],
  defaultLocale: "en"
};
export {
  n as Content,
  e as i18nConfig
};
//# sourceMappingURL=lib.js.map
